module.exports = __webpack_public_path__ + "static/media/sologo.1d9e1d9b.png";